const createBasicAuthToken = (username, password) => {
        return 'Basic ' + window.btoa(username + ":" + password)
}

export default createBasicAuthToken